import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

import Shimmer from "components/ui/shimmer"
import { jewlr_t } from "helpers/application"

import { LinkButton } from "./components"

const CartTitle = ({ cartData, cartLoaded }) => {
  const itemsCount = cartData.line_items?.length || 0

  return (
    <div className="tablet:mt-32 tablet:mb-0 mb-10 w-full text-center">
      <div className="tablet:items-center flex items-baseline justify-between">
        <div className="flex items-baseline">
          <h1 className="text-28 tablet:text-32 leading-36 mr-6 font-bold text-black">
            My {jewlr_t("Cart")}
          </h1>
          {cartLoaded ? (
            <p className="text-14 leading-16 tracking-tigher font-medium">
              ({itemsCount} item{itemsCount > 1 ? "s" : ""})
            </p>
          ) : (
            <Shimmer style={{ height: "16px", width: "50px" }} />
          )}
        </div>
        {cartLoaded ? (
          <div className="flex items-center">
            <LinkButton asChild>
              <Link data-lc="cart-title" to="/">
                Continue Shopping
              </Link>
            </LinkButton>
          </div>
        ) : (
          <Shimmer
            className="w-(--base-width) tablet:w-(--tablet-width)"
            style={{
              "--base-width": "100px",
              "--tablet-width": "170px",
              height: "20px",
            }}
          />
        )}
      </div>
    </div>
  )
}

CartTitle.propTypes = {
  cartData: PropTypes.object,
  cartLoaded: PropTypes.bool,
}

const mapStateToProps = (state) => ({
  cartLoaded: state.cart.cartLoaded,
})

export default connect(mapStateToProps)(CartTitle)
